import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html'
})
export class ButtonComponent implements OnInit {
	@Input() color: string = '0068B4';
	@Input() type: string = 'button';

	@Input() isspinner = false;
	@Input() disabled = false;
	@Input() btnclass = "btn btn-primary";
	@Input() showspinner = false;
	apiProgressChangeSubscription: Subscription;
	isApiProgress: boolean = false;

	constructor(private spinner: NgxSpinnerService,
				public commonService: CommonService) {

		this.apiProgressChangeSubscription = this.commonService.getApiProgressChangeEvent().subscribe(result => {
			if (result.progresscount != 0) {
				this.isApiProgress = true;
				if (this.isspinner) this.spinner.show();
			}
			else {
				this.isApiProgress = false;
				if (this.isspinner) this.spinner.hide();
            }
		});		
    }

    ngOnInit() {

    }

	btnClick() {
		if (this.isspinner) {
			this.spinner.show();
        }
	}

	ngOnDestroy() {
	  // unsubscribe to ensure no memory leaks
	   this.apiProgressChangeSubscription.unsubscribe();
		
	}
}
